import { ModelBase } from './model';

class RoleAssignment extends ModelBase {
  static namespace = 'role_assignment';

  static path = '/api/v2/users/role_assignments/';
}
export default RoleAssignment.register();
